export enum PaginationEngine {
  client,
  server
}
